var exports = {
  "Ke": "xcc377c0b--4bd551--no_image",
  "UT": "xcc377c0b--4bd551--no_image--with_text",
  "SB": "xcc377c0b--4bd551--no_image-icon",
  "wv": "xcc377c0b--4bd551--no_image-text",
};

module.exports = exports;
